<template>
    <svg class="w-6 h-6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
        <path d="M19 14l-7 7m0 0l-7-7m7 7V3" stroke="#ffffff"></path>
    </svg>
</template>